import React, { FC, useContext, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Redirect, RouteComponentProps } from "react-router";
import { Link, Route, Switch } from "react-router-dom";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import ProductContext from "../../index";
import OrganizationProductPurchasesPage from "./pages/Purchases";
import OrganizationProductSalesPage from "./pages/Sales";
import OrganizationProductStockAdjustmentsPage from "./pages/StockAdjustments";
import OrganizationProductTransfersPage from "./pages/Transfers";

const OrganizationProductDocumentsPage: FC<RouteComponentProps> = (props) => {
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const productContext = useContext(ProductContext);

	const getDocumentTabTitle = () => {
		const pathname = props.location.pathname;

		if (pathname.includes("purchases")) return t("modules.purchase.header.title");
		if (pathname.includes("sales")) return t("modules.order.header.title");
		if (pathname.includes("transfers")) return t("modules.transfer.header.title");
		if (pathname.includes("stock_adjustments")) return t("modules.stock_adjustment.header.title");

		return "";
	};

	useEffect(() => {
		handleChangeTabTitle(
			`${productContext.product?.name || ""} | ${
				productContext.product?.type === "PACKAGE"
					? t("modules.package.header.title")
					: t("modules.product.header.title")
			} (${getDocumentTabTitle()})`
		);
	}, [props.location.pathname]);

	const isTabActive = (tabName: string) => {
		return props.location.pathname.includes(tabName);
	};

	return (
		<>
			<Form.Group className="form-group" style={{ marginBottom: "12px" }}>
				<Link
					to={`${props.match.url}/purchases`}
					className={`btn mb-1 ${isTabActive("purchases") ? "btn-outline-primary" : "btn-default"}`}
				>
					{t("modules.purchase.header.title")}
				</Link>
				<Link
					to={`${props.match.url}/sales`}
					className={`btn mb-1 ${isTabActive("sales") ? "btn-outline-primary" : "btn-default"}`}
				>
					{t("modules.order.header.title")}
				</Link>
				<Link
					to={`${props.match.url}/transfers`}
					className={`btn mb-1 ${isTabActive("transfers") ? "btn-outline-primary" : "btn-default"}`}
				>
					{t("modules.transfer.header.title")}
				</Link>
				<Link
					to={`${props.match.url}/stock_adjustments`}
					className={`btn mb-1 ${isTabActive("stock_adjustments") ? "btn-outline-primary" : "btn-default"}`}
				>
					{t("modules.stock_adjustment.header.title")}
				</Link>
			</Form.Group>
			<Switch>
				<Route path={`${props.match.url}/purchases`} exact component={OrganizationProductPurchasesPage} />
				<Route path={`${props.match.url}/sales`} exact component={OrganizationProductSalesPage} />
				<Route path={`${props.match.url}/transfers`} exact component={OrganizationProductTransfersPage} />
				<Route
					path={`${props.match.url}/stock_adjustments`}
					exact
					component={OrganizationProductStockAdjustmentsPage}
				/>
				<Redirect path={props.match.url} to={`${props.match.url}/purchases`} />
			</Switch>
		</>
	);
};
export default OrganizationProductDocumentsPage;
